function ReactText() {
    return (
      <div>
        Integration with React Components
      </div>
    );
   };
   export default ReactText;